import Vue from 'vue';
import firebase from 'firebase/app'
import 'firebase/firestore';
require('firebase/auth');
import { firestorePlugin } from 'vuefire'


Vue.use(firestorePlugin)

const config = {
  apiKey: "AIzaSyCLSzik0UEZRuCdkDZ-2I_aud6JBl4LHFs",
  authDomain: "flow-administration.firebaseapp.com",
  databaseURL: "https://flow-administration.firebaseio.com",
  projectId: "flow-administration",
  storageBucket: "flow-administration.appspot.com",
  messagingSenderId: "161180855428"
};

firebase.initializeApp(config)

// Initialize Cloud Firestore through Firebase
const db = firebase.firestore();

export default db
export const firebaseApp = firebase
